const translation = {
  // Navbar
  "nav.home": "Laman Utama",
  "nav.about": "Tentang Kami",
  "nav.tours": "Pakej Pelancongan",
  "nav.gallery": "Galeri",
  "nav.testimonials": "Testimoni",
  "nav.contact": "Hubungi Kami",
  "nav.bookNow": "Tempah Sekarang",
  "nav.busTickets": "Tiket Bas",
  "nav.certifications": "Pensijilan",

  // Hero
  "hero.slide1.headline": "Teroka Dunia",
  "hero.slide1.sub": "dengan Penuh Yakin",
  "hero.slide1.tagline": "Rakan pelancongan dipercayai Malaysia sejak 2008. Mencipta perjalanan luar biasa untuk lebih 20,000 pengembara gembira.",
  "hero.slide2.headline": "Temui Asia",
  "hero.slide2.sub": "Melampaui Imaginasi",
  "hero.slide2.tagline": "Dari bunga sakura Jepun hingga kuil-kuil Bali — Asia menanti ketibaan anda.",
  "hero.slide3.headline": "Destinasi Impian",
  "hero.slide3.sub": "Harga Yang Berpatutan",
  "hero.slide3.tagline": "Dari Eropah hingga Maldives, kami menjadikan percutian impian anda satu kenyataan yang indah.",
  "hero.badge": "Arus Travel & Tours Sdn Bhd",
  "hero.cta.explore": "Jelajah Pakej",
  "hero.cta.bus": "Tempah Tiket Bas",
  "hero.cta.contact": "Hubungi Kami",

  // Featured Tours
  "featured.badge": "Dipilih Khas Untuk Anda",
  "featured.title": "Pakej Pelancongan Pilihan",
  "featured.subtitle": "Teroka pakej perjalanan terpilih kami — setiap satu direka untuk mencipta kenangan yang kekal seumur hidup.",
  "featured.viewAll": "Lihat Semua Pakej",
  "featured.viewDetails": "Lihat Butiran",
  "featured.perPax": "/ pax",
  "featured.reviews": "ulasan",

  // Popular Destinations
  "destinations.badge": "Ke Mana Hendak Pergi",
  "destinations.title": "Destinasi Popular",
  "destinations.subtitle": "Dari syurga tropika hingga keajaiban budaya — temui destinasi paling memukau di dunia.",
  "destinations.explore": "Teroka Sekarang",
  "destinations.packages": "pakej",

  // Bus Ticketing
  "bus.badge": "Bas Ekspres Antara Bandar",
  "bus.title": "Tempah Tiket Bas Anda",
  "bus.titleHighlight": "Cepat & Mudah",
  "bus.description": "Melancong dalam Malaysia? Tempah tiket bas ekspres antara bandar anda secara dalam talian melalui rakan kongsi dipercayai kami Easybook — meliputi laluan utama di Semenanjung dengan pengendali berlesen.",
  "bus.bookNow": "Tempah Tiket Bas Sekarang",
  "bus.poweredBy": "Tempahan tiket bas dikuasakan oleh platform rakan kongsi kami",
  "bus.f1.label": "Laluan Antara Bandar",
  "bus.f1.desc": "KL, Pulau Pinang, JB & lain-lain",
  "bus.f2.label": "Selamat & Boleh Dipercayai",
  "bus.f2.desc": "Pengendali berlesen sahaja",
  "bus.f3.label": "Tempahan Serta-merta",
  "bus.f3.desc": "E-tiket dalam beberapa saat",
  "bus.f4.label": "Tambang Terbaik",
  "bus.f4.desc": "Tiada caj tersembunyi",

  // Why Choose Us
  "why.badge": "Janji Kami",
  "why.title": "Mengapa Pilih Arus Travel?",
  "why.subtitle": "Kami lebih daripada sekadar menempah penerbangan dan hotel — kami mencipta pengalaman yang anda akan hargai selama-lamanya.",
  "why.r1.title": "Berlesen & Dipercayai",
  "why.r1.desc": "Berlesen sepenuhnya oleh Kementerian Pelancongan Malaysia (MOT) dan ahli MATTA serta IATA yang berbangga. Keselamatan dan kepuasan anda adalah keutamaan kami.",
  "why.r2.title": "Sokongan 24/7",
  "why.r2.desc": "Konsultan pelancongan kami sedia membantu anda sepanjang masa — sebelum, semasa dan selepas perjalanan anda.",
  "why.r3.title": "Jaminan Harga Terbaik",
  "why.r3.desc": "Kami merunding kadar terbaik dengan syarikat penerbangan dan hotel supaya anda mendapat nilai terbaik — tiada fi tersembunyi.",
  "why.r4.title": "Itinerary Yang Disesuaikan",
  "why.r4.desc": "Setiap perjalanan yang kami cipta disesuaikan mengikut pilihan, gaya perjalanan dan bajet anda — dari solo hingga kumpulan besar.",
  "why.r5.title": "Pemandu Tempatan Pakar",
  "why.r5.desc": "Rangkaian pemandu tempatan kami yang berpengalaman dan pelbagai bahasa memperkayakan pengalaman perjalanan anda dengan wawasan budaya yang tulen.",
  "why.r6.title": "20,000+ Pengembara Gembira",
  "why.r6.desc": "Lebih 17 tahun pengalaman dan ribuan pelanggan berpuas hati — kami berbangga dinilai 4.9/5 bintang di semua platform.",

  // Stats
  "stats.badge": "Rekod Kami",
  "stats.title": "Dua Dekad Kecemerlangan Pelancongan",
  "stats.l1": "Tahun Kecemerlangan",
  "stats.l2": "Destinasi Seluruh Dunia",
  "stats.l3": "Pengembara Gembira",
  "stats.l4": "Penilaian Pelanggan",

  // Testimonials
  "testimonials.badge": "Apa Kata Pelanggan Kami",
  "testimonials.title": "Kisah Pengembara",
  "testimonials.subtitle": "Dengar daripada ribuan pengembara gembira yang mempercayai Arus Travel untuk mencipta percutian sempurna mereka.",
  "testimonials.readAll": "Baca Semua Ulasan",

  // CTA
  "cta.badge": "Mulakan Pengembaraan Anda",
  "cta.title": "Percutian Impian Anda",
  "cta.titleLine2": "Bermula Di Sini",
  "cta.subtitle": "Bercakap dengan konsultan pelancongan kami hari ini dan biarkan kami mereka perjalanan sempurna yang disesuaikan untuk anda. Tanpa obligasi, tanpa kerumitan — hanya nasihat perjalanan terbaik.",
  "cta.browse": "Lihat Semua Pelancongan",
  "cta.consultation": "Dapatkan Konsultasi Percuma",

  // Footer
  "footer.tagline": "Rakan perjalanan anda yang dipercayai sejak 2008. Kami mencipta perjalanan yang tidak dapat dilupakan, memberikan perkhidmatan luar biasa di setiap langkah.",
  "footer.quickLinks": "Pautan Pantas",
  "footer.destinations": "Destinasi",
  "footer.contactUs": "Hubungi Kami",
  "footer.hours": "Isnin – Sabtu: 9:00pg – 6:00ptg",
  "footer.privacy": "Dasar Privasi",
  "footer.terms": "Terma & Syarat",
  "footer.d1": "Pelancongan Asia Tenggara",
  "footer.d2": "Pelancongan Asia Timur",
  "footer.d3": "Pelancongan Eropah",
  "footer.d4": "Pelancongan Timur Tengah",
  "footer.d5": "Pelancongan Lautan Hindi",
  "footer.d6": "Pakej Bulan Madu",
};

export default translation;
